import type { ReactNode } from "react";

import { Button, Dropdown } from "@heroui/react";
import { Ellipsis } from "lucide-react";

export type RowMenuItem = {
  id: string;
  label: string;
  icon?: ReactNode;
  danger?: boolean;
  /** Shown but not selectable. */
  isDisabled?: boolean;
  onAction: () => void;
};

/** The "…" menu at the end of a table row. The trigger is labelled `label` (default "Row actions"). */
export function RowMenu({
  items,
  label = "Row actions",
}: {
  items: RowMenuItem[];
  label?: string;
}) {
  return (
    <Dropdown>
      <Button isIconOnly aria-label={label} size="sm" variant="ghost">
        <Ellipsis className="size-4" />
      </Button>
      <Dropdown.Popover placement="bottom end">
        <Dropdown.Menu
          onAction={(key) => items.find((item) => item.id === key)?.onAction()}
        >
          {items.map((item) => (
            <Dropdown.Item
              key={item.id}
              id={item.id}
              isDisabled={item.isDisabled}
              textValue={item.label}
              variant={item.danger ? "danger" : "default"}
            >
              {item.icon}
              {item.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown.Popover>
    </Dropdown>
  );
}
